import _possibleConstructorReturn from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _classCallCheck from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\fgrassinger\\Documents\\Arbeitsprojekte\\InteractiveLegend_Bar_Special\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { SourceNode } from './source';
/**
 * Abstract base class for BottomUpOptimizer and TopDownOptimizer.
 * Contains only mutation handling logic. Subclasses need to implement iteration logic.
 */

var OptimizerBase =
/*#__PURE__*/
function () {
  function OptimizerBase() {
    _classCallCheck(this, OptimizerBase);

    this._mutated = false;
  } // Once true, _mutated is never set to false


  _createClass(OptimizerBase, [{
    key: "setMutated",
    value: function setMutated() {
      this._mutated = true;
    }
  }, {
    key: "mutatedFlag",
    get: function get() {
      return this._mutated;
    }
  }]);

  return OptimizerBase;
}();
/**
 * Starts from a node and runs the optimization function(the "run" method) upwards to the root,
 * depending on the continueFlag and mutatedFlag values returned by the optimization function.
 */


export var BottomUpOptimizer =
/*#__PURE__*/
function (_OptimizerBase) {
  _inherits(BottomUpOptimizer, _OptimizerBase);

  function BottomUpOptimizer() {
    var _this;

    _classCallCheck(this, BottomUpOptimizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BottomUpOptimizer).call(this));
    _this._continue = false;
    return _this;
  }

  _createClass(BottomUpOptimizer, [{
    key: "setContinue",
    value: function setContinue() {
      this._continue = true;
    }
  }, {
    key: "reset",

    /**
     * Reset the state of the optimizer after it has completed a run from the bottom of the tree to the top.
     */
    value: function reset() {// do nothing
    }
  }, {
    key: "optimizeNextFromLeaves",
    value: function optimizeNextFromLeaves(node) {
      if (node instanceof SourceNode) {
        return false;
      }

      var next = node.parent;

      var _this$run = this.run(node),
          continueFlag = _this$run.continueFlag;

      if (continueFlag) {
        this.optimizeNextFromLeaves(next);
      }

      return this.mutatedFlag;
    }
  }, {
    key: "continueFlag",
    get: function get() {
      return this._continue;
    }
  }, {
    key: "flags",
    get: function get() {
      return {
        continueFlag: this.continueFlag,
        mutatedFlag: this.mutatedFlag
      };
    },
    set: function set(_ref) {
      var continueFlag = _ref.continueFlag,
          mutatedFlag = _ref.mutatedFlag;

      if (continueFlag) {
        this.setContinue();
      }

      if (mutatedFlag) {
        this.setMutated();
      }
    }
  }]);

  return BottomUpOptimizer;
}(OptimizerBase);
/**
 * The optimizer function( the "run" method), is invoked on the given node and then continues recursively.
 */

export var TopDownOptimizer =
/*#__PURE__*/
function (_OptimizerBase2) {
  _inherits(TopDownOptimizer, _OptimizerBase2);

  function TopDownOptimizer() {
    _classCallCheck(this, TopDownOptimizer);

    return _possibleConstructorReturn(this, _getPrototypeOf(TopDownOptimizer).apply(this, arguments));
  }

  return TopDownOptimizer;
}(OptimizerBase);